import React, { PropTypes } from 'react';
import { withRouter, routerShape } from 'react-router';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ToggleSwitch from '@bibliocommons/base-toggle-switch';
import { PushPin } from '@bibliocommons/base-icons';
import ImmutablePropTypes from 'react-immutable-proptypes';
import updateSearchQuery from '../../../helpers/search/updateSearchQuery';

import './ActiveFilterLockSwitch.scss';


export class ActiveFilterLockSwitch extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleToggleFilterLock');
  }

  handleToggleFilterLock() {
    const { router, location, active, activeFilters, searchType } = this.props;

    const query = updateSearchQuery({
      currentQuery: location.query,
      activeFilters,
      searchType,
      locked: active ? undefined : 'true'
    });

    router.push({ ...location, query });
  }

  render() {
    const { active } = this.props;
    return (
      <ToggleSwitch
        className="cp-active-filter-lock-switch"
        active={active}
        activeLocaleKey="active_filters_locked"
        inactiveLocaleKey="active_filters_unlocked"
        handleClick={this.handleToggleFilterLock}>
        <PushPin className="small" />
      </ToggleSwitch>
    );
  }
}


ActiveFilterLockSwitch.displayName = 'ActiveFilterLockSwitch';
ActiveFilterLockSwitch.propTypes = {
  active: PropTypes.bool.isRequired,
  activeFilters: ImmutablePropTypes.map,
  handleClick: PropTypes.func.isRequired,
  searchType: PropTypes.string,
  router: routerShape
};

export default withRouter(ActiveFilterLockSwitch);



// WEBPACK FOOTER //
// ./app/components/search/ActiveFilterLockSwitch/ActiveFilterLockSwitch.jsx